import comp from "./GrouppedGradeList";
export default comp;
